var BASE_PATH = "HealthivaWebServices/";

//  Pre-prod Environment

//  var PRE_BASE_URL = "http://dev.healthivabillingms.healthiva.com/"; 
//  var API_URL_API = "http://healthivadev.eastus.cloudapp.azure.com/";
//  var BASE_URL_BILLING_API = "http://dev.billingms.healthiva.com/";
//  //var BASE_URL_BILLING_API = "http://localhost:4386/";
//  var BASE_URL_SEARCH_API= "http://dev.searchms.healthiva.com/";
//  var BASE_URL_TIMESHEET_API = "http://dev.timesheetms.healthiva.com/";
//  var BASE_URL_COMMON_API ="http://dev.commondatams.healthiva.com/"
//  var BASE_URL_SERVICES_API ="http://dev.services.healthiva.com/"
//  var BASE_URL_PATIENT_PORTAL_API ="http://dev.patientportalms.healthiva.com/";
//  var BASE_URL_REMIT_API ="https://ms.healthiva.com/";
//  var BASE_DROPDOWN_DATA_API="http://dev.commondata.healthiva.com/CommonData/";
//  var BASE_URL_AUDIT ="http://dev.auditms.healthiva.com/"; 
//  var BASE_URL_APPOINTMENT = "http://dev.appointmentapi.healthiva.com/";
//  var BASE_URL_PRACTICEAPI ="http://dev.practiceapi.healthiva.com/";
//  var BASE_URL_PROVIDERMS ="http://dev.providerms.healthiva.com/";

 // ChatMS - Remi, the AI billing assistant. Backend branch: 0806-ai-chatbot-ms
 // Override with REACT_APP_CHAT_URL so backend devs can point at their own instance
 // without editing this file. Default is the local ChatMS port.
 //var BASE_URL_CHAT_API = process.env.REACT_APP_CHAT_URL || "http://localhost:5284/";
 // var BASE_URL_CHAT_API = "http://dev.chatms.healthiva.com/";   // dev, once deployed
 


//PROD Environment

var API_URL_API = "https://www.healthiva.com/";
var BASE_URL_SEARCH_API="https://searchms.healthiva.com/";
var BASE_URL_BILLING_API ="https://billingms.healthiva.com/"
var BASE_URL_TIMESHEET_API ="https://timesheetms.healthiva.com/";
var BASE_URL_SERVICES_API ="https://services.healthiva.com/";
var BASE_URL_COMMON_API= "https://commondatams.healthiva.com/";
var BASE_URL_PATIENT_PORTAL_API ="https://patientportalms.healthiva.com/";
var BASE_URL_REMIT_API ="https://ms.healthiva.com/";
var BASE_URL_AUDIT ="https://auditms.healthiva.com/";
var BASE_DROPDOWN_DATA_API="https://commondatams.healthiva.com/CommonData/";
var BASE_URL_APPOINTMENT = "https://appointmentapi.healthiva.com/";
var BASE_URL_PRACTICEAPI ="https://practiceapi.healthiva.com/";
var BASE_URL_PROVIDERMS = "https://providerms.healthiva.com/";
var BASE_URL_CHAT_API = "https://chatms.healthiva.com/";

 
 export class APIConstants {
   static APP_NAME = "Healthiva Billing";
   static BASE_URL =   API_URL_API + BASE_PATH; //make sure to change this to PROD_URL, before pushing on prod
   static BASE_URL_BILLING  = BASE_URL_BILLING_API;
   static PRE_BASE_URL = BASE_URL_BILLING_API;
   static BASE_URL_SEARCH = BASE_URL_SEARCH_API;
   static BASE_URL_TIMESHEET = BASE_URL_TIMESHEET_API;
   static COMMON_BASE_URL = BASE_URL_COMMON_API ;
   static SERVICES_URL = BASE_URL_SERVICES_API;
   static PATIENT_PORTAL_URL = BASE_URL_PATIENT_PORTAL_API;
   static BASE_URL_REMIT = BASE_URL_REMIT_API;
   static BASE_AUDIT_URL = BASE_URL_AUDIT;
   static BASE_URL_APPOINTMENT_MS = BASE_URL_APPOINTMENT;
   static BASE_URL_PRACTICE_API = BASE_URL_PRACTICEAPI;
   static BASE_URL_PROVIDER_MS = BASE_URL_PROVIDERMS;
   //static BASE_URL_CHAT = BASE_URL_CHAT_API;

}


/**
 * ChatMS - Remi, the AI billing assistant.
 *
 * These deliberately DO NOT use the `?sInputJSON={...}` query-string convention used by the
 * rest of this file. Chat payloads carry PHI (patient names, MRNs, DOS, claim detail) and
 * query strings land in server access logs and every intermediary. POST bodies and normal
 * query params only. Do not "fix" this for consistency.
 *
 * Full contract: ChatMS/ChatMS/docs/Chat.md on branch 0806-ai-chatbot-ms
 */
export class ChatConstants {
   static SendMessage      = "Chat/SendMessage";       // POST - ask a question, get an answer
   static GetConversations = "Chat/GetConversations";  // GET  - list this user's conversations
   static GetConversation  = "Chat/GetConversation";   // GET  - load one thread's history
   static SaveFeedback     = "Chat/SaveFeedback";      // POST - thumbs up/down on an answer
   static GetSuggestions   = "Chat/GetSuggestions";    // GET  - personalised starter prompts
}



export const ERROR_MESSAGE = "Something went wrong!";





//-------- API Constants ---------


export class LoginConstants {
    static GetLogin = "Authentication/Authenticate";
    static UpdatedToken = "authentication/GetAuthToken";
    static Logout ="Authentication/Logout";
    static SendOtp ="Authentication/SendOtp";
    static VerifyOtp ="Authentication/VerifyOtp";
 }



 
export class FilesAPIConstants {
   static ExcelFile ="DataExport/Excel";
   static PdfFile ="Billing/EncounterPDF";
   static ExportPdfFile ="DataExport/PDF";
}



 
export class CommonAPIConstants {
   static GetAllclearingHouse = "HealthivaGenralUtilityWS.asmx/GetAllClearingHouseDetails";
   static CheckPatientEligibility ="/PortalServices.asmx/CheckPatientsEligibility";
   static GetCPTList ="BillingPatientDetails.asmx/GetMasterCPTsNew";
   static GetAllCPTList ="Search/CPT"
   static GetModList ="patientDetails.asmx/GetModifiersNew";
   static GetIcdList ="patientDetails.asmx/getICDNew";
   static GetInsCompanyNames ="PortalServices.asmx/getInsCompanyNamesNew";
   static GetPatientInsurance ="PatientInsuranceDetails/PatientDOSInsurance";
   static GetAllPatientInsurance ="PortalServices.asmx/GetPatientAllInsuranceDetails"
   static GetInsuCompanyNames ="Search/SearchInsurance";
   static GetAllPatientNames = "Search/SearchPracticePatients";
   static GetUserClockIn ="TimeSheet/CheckinInUser";
   static GetUserClockOut ="TimeSheet/CheckOutUsers";
   static GetUserClockStatus="TimeSheet/CheckUserCheckinStatus";
   static GetRenderingProviders = "CommonData/GetPracticeProviders";
   static GetIntelliUpdatedClaims ="HealthivaBillingWS.asmx/UpdateSelectedClaims";
   static UpdateClaimNotes ="PostingPayment/ClaimNotes";
   static SaveAdjustmentCharges = "PostingPayment/CPTAdjustment";
   static SaveSecPendingCharges = "PostingPayment/CPTSecPending";
   static GetClaimAllEvents = "DataEvent/GetClaimAllEvents";

   static GetAllInsCompanyNames ="Search/SearchInsurance";
   static GetPDFCMS1500 ="Billing/CMS1500Path";
   static SaveRegeneratePDFCMS1500 ="Billing/RegenerateCMS1500";
   static GetClaimSubmitHx ="Billing/ClaimSubmitHx";
   static GetPatientEligibility ="PatientInsuranceDetails/PatientEligibility";
   static DeleteClaim ="ClaimApproval/DeleteClaims"
   static SaveForApproval = "Billing/UpdateClaims";
   static GetAllWorkableClaimsCounts ="Billing/WorkableClaimsCount"
   static GetPatientDemography ="PatientDemography"
   static GetPatInsuranceDetails = "PatientInsuranceDetails"
   static GetMasterRelation ="CommonData/GetMasterRelation"
   static SavePatientInsurance ="PatientInsuranceDetails/SaveInsurance";
   static UpdatedPatInsurance ="PatientInsuranceDetails/UpdateInsurance"
   static DeletePrimaryInsurance ="PatientInsuranceDetails/DeleteInsuranceDetails"
   static MarkInsuraceInactive ="PatientInsuranceDetails/MarkInsuraceInactive"
   static UpdatedActiveEndDate ="PatientInsuranceDetails/UpdateEndDate"
   static GetAllMacroDetails ="Billing/MacroDetails"
   static PatientEligibilityDetails ="PatientInsuranceDetails/EligibilityDetails"
   static GetTransactionData ="PatientBilling/PatientTransactions"
   static GetGeneralDocs ="Document/GeneralDocs"
   static UpdatedDocument ="Document/UpdateDocument"
   static DeleteDocument ="Document/GeneralDocument"
   static GetPatientAppointments ="PatientAppointment/PatientAppointments";
   static GetPatientPADetails="PatientAPI/PatientPADetails";
   static GetLocationDetails ="CommonData/GetLocationDetails";
   static SavePatientNotes ="PatientAPI/SavePatientNotes";
   static SavePatientAlertNotes ="PatientAPI/SavePatientAlertNotes";
   static SaveGetPatientNotes ="PatientAPI/GetPatientNotes";
   static GetPatientNotes ="PatientAPI/GetPatientNotes";
   static GetPatientAlertNotes ="PatientAPI/PatientAlertNotes"
   static SavePatAddress ="PatientDemography/Address"
   static SaveContactNumber ="PatientDemography/ContactNumber"
   static SaveZipDetails ="PatientDemography/ZipDetails"
   static CPTDcoument="Document/CPTEncounterDocument"
   static GetBilling32AData ="CommonData/GetPracticeBillingNPI";
   static GetBilling33AData ="CommonData/GetPractceCMS33AData";
   static GetBilling33BData ="CommonData/GetPractceCMS33BData";
   static GetCPTServiceData ="CommonData/CPTServiceNames";
   static UpdateBilling32AData ="CPT/UpdateBox32aforCPT";
   static UpdateBilling33AData ="CPT/UpdateBox33aforCPT";
   static UpdateBilling33BData ="CPT/UpdateBox33bforCPT";
   static UpdateCPTServiceData ="CPT/UpdateCPTServiceRole";
   static ApplyCopay ="PostingPayment/ApplyCopay";
   static UpdatePatLocation ="Appointment/UpdatePatLocation";
   static GetZipDetails ="HealthivaGenralUtilityWS.asmx/getPatientCityName"
   static GetPatientRefPhysician ="PatientDemography/PatientRefPhysician";
   static GetClearingHouse ="CommonData/GetClearingHouseData";
   static CheckisDuplicatePhoneNumber ="PatientAPI/CheckIsDuplicatePhoneNumber";
   static GetClaimAttachments ="MedicalClaim/GetClaimAttachments";
   static SavePatientCredentials ="PatientAPI/SavePatientCredentials";
   static SavePatientMessage  ="Messsaging/PatientMessage";
  }




export class DashboardConstants {
   static GetDashboardCounts = "Billing/GetBillingDashboardCounts";
   static GetDenRejReasons = "BillingDashboardAPIs.asmx/GetBillingDashboardDeniedAndRejectedReasons";
   static GetDashboardStats ="BillingDashboardAPIs.asmx/GetBillingDashboardStats";
   static GetCHSubmittedClaims ="Billing/CHSubmittedClaims";
   static GetProviderClaimsCount ="Billing/ProviderClaimsCount";
   static GetCPTClaimsCount ="Billing/CPTClaimsCount";

}



export class IntelliBillConstants {
    static GetIntelliDropDowns = "CommonData/BillingDropdownData";
    static GetIntelliPatientNames = "Search/SearchPracticePatients";
    static GetIntelliProvidersNames ="patientDetails.asmx/GetPracticeProvidersNew";
    static GetIntelliInsCompanyNames ="Search/SearchInsurance";
    static GetIntelliTabledata ="IntelliBill";
    static GetIntelliUpdatedClaims ="HealthivaBillingWS.asmx/UpdateSelectedClaims";
    static GetIntelliAddNewClaim="Billing/GenerateNewClaim";
    static DeleteclaimICDDetails ="HealthivaBillingWS.asmx/DeleteClaimICDDetailsNew";
    static CloseClaimCPT ="Billing/CloseClaimCPT";
    static GetVerifyEPIN ="Authentication/VerifyEPIN";
    
 }



 

export class ClaimApprovalConstants {
   static GetApprovalPageClaims = "ClaimApproval/GetApprovalPageClaims";
   static SaveApprovalClaims = "ClaimApproval/ApproveClaims";
   static GetClaimDropDowns = "HealthivaBillingWS.asmx/GetDataForClaimApprovalDropDowns";
   static GetSuggestionDropDowns = "HealthivaGenralUtilityWS.asmx/GetPracticeBillingUsersNew";
   static GetPracticeClaimStatusCount = "ClaimApproval/GetPracticeClaimStatusCount"
}
 


export class LabBillingConstants {
   static GetLabBillingTable = "LabBilling/LabBillingData";
   static GetLabDropDown = "HealthivaBillingWS.asmx/GetLabNames";
  
   static GenerateLabClaims = "Billing/GenerateNewClaim";
   static GenerateDownloadFile = "DataExport/DownLoadFiles";
}
 


export class ClaimStatusConstants {
   static GetClaimStatusData = "ClaimStatus/ClaimStatusData";
   static GetClaimServices = "HealthivaGenralUtilityWS.asmx/GetCPTServiceNames";
   static GetPracticeBillingNPIs = "HealthivaBillingWS.asmx/GetPracticeBillingNPIsNew";
   static GetTransactionCode = "HealthivaGenralUtilityWS.asmx/GetTransactionCode";
   static SaveClaimCPTAdminWriteOffCharges = "ClaimStatus/ClaimCPTAdminWriteOffCharges";
   static SaveVerifiedData = "BillingClaimReconcillation.asmx/SaveClaimVerificationDetailsNew";
   static SaveClaimRecvdData = "BillingClaimReconcillation.asmx/SaveClaimReceivedChargesNew";
   static SaveCPTRecvdData = "BillingClaimReconcillation.asmx/SaveCPTReceviedChargeNew";
   static SaveClaimWriteOffData = "BillingClaimReconcillation.asmx/SaveClaimWriteOffsChargesNew";
   static SaveClaimCPTWriteOffData = "BillingClaimReconcillation.asmx/SaveClaimCPTWriteOffsChargesNew";
   static SaveClaimChequeNumberNew = "BillingClaimReconcillation.asmx/SaveClaimChequeNumberNew";
   static SaveCPTChequeNumberNew = "BillingClaimReconcillation.asmx/SaveCPTChequeNumberNew";
   static SaveClaimChequeDate = "BillingClaimReconcillation.asmx/SaveClaimChequeDateNew";
   static SaveCPTChequeDate = "BillingClaimReconcillation.asmx/SaveCPTChequeDateNew";
   static MarkClaimCPTasClosed = "BillingClaimReconcillation.asmx/MarkClaimCPTasClosedNew";
   static CloseClaimWithCPT = "HealthivaBillingWS.asmx/CloseClaimCPTsNew";
   static UpdateClaimsPayerRefID = "HealthivaBillingWS.asmx/UpdateClaimsPayerRefID";
   static UpdateClaimNotesNew = "HealthivaBillingWS.asmx/UpdateClaimNotesNew";
   static UpdateCopayData = "PostingPayment/Copay";
  
}

export class PatientStatementsConstants {
   static RequestFromLedger = "PatientStatements/request-from-ledger";
   static GetStatementRequests = "PatientStatements/requests";
   static GetStatementWorkflowSummary = "PatientStatements/workflow-summary";
   static GetStatementWorkflowList = "PatientStatements/workflow-list";
   static GetStatementById = "PatientStatements/{id}";
   static ApproveStatement = "PatientStatements/approve";
   static RejectStatement = "PatientStatements/reject";
   static MarkGenerated = "PatientStatements/mark-generated";
   static GenerateInvoice = "PatientStatements/generate-invoice";
   static GenerateReceipt = "PatientStatements/generate-receipt";
   static RegenerateFromLedger = "PatientStatements/regenerate-from-ledger";
   static GetFrontDeskDashboard = "PatientStatements/front-desk-dashboard";
   static GetBillingDeskLedger = "PatientStatements/billing-desk-ledger";
}



export class NewEncounterConstants {
    static AddNewCPTtoClaims ="/HealthivaBillingWS.asmx/AddNewCPTtoClaims";
    static UpdateClaimDetails ="MedicalClaim/UpdateClaim";
    static SaveSecondaryClaim ="MedicalClaim/SecondaryClaim";
    static GenerateNewClaim ="Billing/GenerateNewClaim";
    static DeleteClaimCPT ="MedicalClaim/ClaimCPT";
    static CorrectPartiallyDenied="MedicalClaim/CorrectPartiallyDeniedClaims";
    static GetClaimAttachments ="MedicalClaim/GetClaimAttachments";
    static GetPatientAllDocumentDetails ="Document/GetPatientAllDocumentDetails";
    static DeleteClaimAttachment ="MedicalClaim/DeleteClaimAttachment";
    static UploadClaimAttachments ="MedicalClaim/UploadClaimAttachments";
    static GetClaimAttachmentTypes="CommonData/ClaimAttachmentTypes";
}




export class PostingpaymentsConstants {
   static GetInsuranceClaimReconData ="Billing/GetInsuranceClaimReconData";
   static GetPracticeClaims ="PostingPayment/GetPracticeClaims";
   static UpdateClaimDeductible ="PostingPayment/ClaimDeductible";
   static UpdateClaimPatientResponsibility ="PostingPayment/ClaimPatientResponsibility";
   static CPTReceviedCharge ="PostingPayment/CPTReceviedCharge";
   static UpdateWriteoff ="PostingPayment/ClaimWriteOff";
   static UpdateCheckNumber ="PostingPayment/ClaimChequeNumber";
   static UpdateCheckDate ="PostingPayment/ClaimChequeDate";
   static UpdateClaimNotes ="PostingPayment/ClaimNotes";
   static UpdateClaimReferencenumber ="PostingPayment/ClaimReferencenumber";
   static SaveFedReduction="PostingPayment/FedReduction";
   static SaveSelfPay="PostingPayment/SelfPay";
   static savOtherAdjustment="PostingPayment/OtherAdjustment";

}


export class InsurancePaymentReportConstants{
   static GetInsurancePaymentReport ="ReportsAPI/GetInsurancePaymentReport"
}




export class AgingReportConstants{
   static GetAgingReport ="ReportsAPI/GetARAgingReport"
   static GetAgingReportDetails ="ReportsAPI/GetAgingReportDetails"
}


export class EditCPTConstants{
   static GetPracticeCPTList ="CPT/PracticeCPTList";
   static SaveNewCPTtoList ="CPT/SaveNewCPTToPractice";
   static UpdateCPTtoList ="CPT/UpdateCPT";
   static CheckIsDuplicateCPT ="CPT/CheckIsDuplicateCPT";
   static EditUnitCalculation ="CPT/EditUnitCalculation";
}




export class TransactionLogsConstants{
   static GetMouleAudits ="Audit/GetMouleAudits";
   static GetClaimTrnsDetails="Billing/ClaimTrnsDetails";
}



export class PendingConstants {
   static GetPendingClaims ="Billing/GetPendingClaims";
  

}




export class RejectedConstants {
   static GetRejectedClaims ="Billing/GetRejectedClaimsDetails";
}




export class DeniedConstants {
   static GetDeniedClaims ="Billing/GetDeniedClaimsDetails";
}



export class ExpiringConstants {
   static GetExpiringClaims ="Billing/GetPracticeExpiringClaims";
}



export class ErrorConstants {
   static GetErrorClaims ="Billing/GetValidationFailedClaimsDetails";
}




export class ClosedConstants {
   static GetClosedClaims ="Billing/GetPracticeClosedClaims";
}




export class SubmissionConstants {
   static GetSubmissionClaims ="Billing/GetPracticeSubFailedClaims";
}




export class RemittanceConstants {
   static GetRemittanceFileDetails ="ManualRemittance/RemittanceFileDetails";
   static GetRemitFileWebPath ="ManualRemittance/RemitFileWebPath";
   static ProcessRemitanceFile ="835parsing/ProcessRemittance/ProcessManualRemitFiles"
   static UploadingFile ="ManualRemittance/UploadFile"
   static GetMultipleClaimDetails ="ManualRemittance/GetMultipleClaimDetails"
   static DeleteRemitFile ="ManualRemittance/RemitFile"
   static GetVerifiedClaim ="Billing/MultipleClaimVerify"
   static ReProcessRemitFile ="835parsing/ProcessRemittance/ReProcessRemitFile";
   static GetAutoRemitFiles ="ManualRemittance/AutoRemitFiles"
}





export class MacroConstants {
   static GetAllMacro ="BillingMacro/AllMacro";
   static SaveMacroDetails ="BillingMacro/MacroDetails";
   static DeleteMacro ="BillingMacro/Macro";
   static UpdateMacro ="BillingMacro/MacroUpdate";
  
}







export class SuperBillConstants {
   static GetSuperBillData ="SuperBill";
   
}





export class PatientTrackerConstants{
   static GetProviderEncounterTrackerData ="PatientTrackerAPI/GetProviderEncounterTrackerData";
   static GetRoleBasedCPTTrackerData ="PatientTrackerAPI/GetRoleBasedCPTTrackerData";
   static GetRoleBasedCPTUnitsData ="PatientTrackerAPI/GetRoleBasedCPTUnitsData";
   static GetPatientTrackerDetailedData ="PatientTrackerAPI/GetPatientTrackerDetailedData"
   static GetUserAudits ="Audit/GetUserAudits"
   static GetCounselorEncounterTrackerData ="PatientTrackerAPI/GetCounselorEncounterTrackerData";


}




export class PatientDMTabConstants{
   static GetMasterEthnicity ="CommonData/MasterEthnicity";
   static GetMasterRace ="CommonData/MasterRace";
   static GetMasterMaritalStatus ="CommonData/MasterMaritalStatus";
   static UpdatePersonalInformation ="PatientDemography/UpdatePersonalInformation";
   static SavePatientAddressDetails ="PatientDemography/SavePatientAddressDetails";
   static SavePatientContactDetails ="PatientDemography/UpdateGeneral";
   static SavePCPPhysician="PatientDemography/SavePCPPhysician";
   static GetPatientConsultedPhyDetails ="PatientDemography/PatientConsultedPhyDetails";
   static GetEmergencyCotactDetails ="PatientDemography/EmergencyCotactDetails";
   static GetCityData ="CommonData/MasterCity";
   static GetCountriesData ="User/Countries";
   static GetLanguages ="User/Languages";
   static GetZipCode ="PatientDemography/CityStateCountryByZip";
}




export const convertDateFormat = (dateString) => {
  if(dateString.includes('-')) 
  
  {const [year, month, day] = dateString.split("-");
   return `${month}/${day}/${year}`;
}else
{
  return dateString;
}
 };



 

 export const formatDOSDate = (dateString) => {
   if (!dateString) return ""; // Return empty string if dateString is falsy

   const date = new Date(dateString);
   if (isNaN(date.getTime())) {
     return ""; // Return empty string if date is invalid
   }

   return date.toLocaleDateString("en-US", {
     year: "numeric",
     month: "2-digit",
     day: "2-digit",
   });
 };

 
 export const formatAppointMentDate = (dateString) => {
   if (!dateString) return ""; // Return empty string if dateString is falsy
   const timestamp = parseInt(dateString.match(/\d+/)[0], 10);
   const date = new Date(timestamp);

   if (isNaN(date.getTime())) {
     return "";
   }
   const year = date.getFullYear();
   const month = String(date.getMonth() + 1).padStart(2, "0");
   const day = String(date.getDate()).padStart(2, "0");
   return `${month}/${day}/${year}`;
 };
